import React, { Component } from "react";
import RestServiceStatic from "../services/rest.service"
import Header from "../components/Header";
import Footer from "../components/Footer";
import FollowingList from "../components/FollowingList";
import NotificationBox from "../components/NotificationBox";
import FollowingPlaceholder from "../components/FollowingPlaceholder";
import { MAX_RETRIES } from "../Constants";
import { Card, Container, Spinner } from "react-bootstrap";
import ShareTootNotification from "../components/ShareTootNotification";

export default class Followings extends Component {

    constructor(props) {

        super(props);

        this.retrieveFollowings = this.retrieveFollowings.bind(this);

        this.state = {
            verified: [],
            suggested: [],
            loaded: false,
            retries: 0
        }

        let pixelfedToken = localStorage.getItem('pixelfedToken');
        let jwt = localStorage.getItem('jwt');

        if (!pixelfedToken || !jwt) {
            window.location.href = "/"
        }
    }

    render() {
        return (
            <div className="content">
                <Header />
                <div className="mt-5"/>
                {this.state.loaded && ((this.state.verified && this.state.verified.length > 0) || (this.state.suggested && this.state.suggested.length > 0)) ? 
                    <ShareTootNotification number={(this.state.verified ? this.state.verified.length : 0) + (this.state.suggested ? this.state.suggested.length : 0) }/>
                    :
                    ""
                }
                
                <h3 className="text-center logo-gradient">
                    {!this.state.loaded || 
                    (this.state.verified && this.state.verified.length) || 
                    (this.state.suggested && this.state.suggested.length) 
                        ? "3. Follow your friends!" 
                        : "Sorry we have not found any of your friends yet"
                    } 
                </h3>
                <div className="mt-4"/>
                {(this.state.verified && this.state.verified.length) || (this.state.suggested && this.state.suggested.length)  
                            ? <NotificationBox msg="We can notify you every time a new verified friend is found." />
                            : (this.state.loaded ? 
                            <NotificationBox msg="Currently we have not been able to find any of your friends, but we can notify you every time a new verified friend is found." /> 
                            : "")
                } 
                <div className="mt-3"/>
                <FollowingList followings={this.state.verified} verified={true}/>
                <div className="mt-3"/>
                <FollowingList followings={this.state.suggested} verified={false}/>
                <div className="mt-3"/>
                {!this.state.loaded ?
                <div>
                <div className="mt-3"/>
                <Container>
                    <Card className="alert alert-warning warning-box placeholder-glow text-center">
                        <span><div className="rounded-circle border spinner-size placeholder"></div> Looking for friends. This may take a long, please be patient :) </span>   
                    </Card>
                </Container>
                <div className="mt-3"/>
                <FollowingPlaceholder/>
                <div className="mt-3"/>
                <FollowingPlaceholder/>
                <div className="mt-3"/>
                <FollowingPlaceholder/>
                </div> : ""}
                
                <div className="mt-5"/>
                <Footer />
            </div>
        );
    }

    componentDidMount() {
        this.retrieveFollowings();
    }

    retrieveFollowings(lastIndex) {

        let pixelfedToken = localStorage.getItem('pixelfedToken');
        let pixelfedInstance = localStorage.getItem('pixelfedInstance');

        RestServiceStatic.getPendingFollowings(pixelfedToken, pixelfedInstance, lastIndex).then(response => {

            var verifiedList = this.state.verified;
            var suggestedList = this.state.suggested;

            verifiedList.push.apply(verifiedList, response.data.verifiedList);
            suggestedList.push.apply(suggestedList, response.data.suggestedList);

            this.setState({ verified: verifiedList, suggested: suggestedList, loaded: !response.data.pendingResults, retries: 0 });

            if (response.data.pendingResults) {
                this.retrieveFollowings(response.data.lastIndex)
            }

        }).catch(e => {

            console.log("CATCH:" + e);

            let retires = this.state.retries;

            if (retires < MAX_RETRIES) {
                console.log("Retrying for " + lastIndex);
                this.retrieveFollowings(lastIndex);
                this.setState({retries: (retires+1) });
            } else {
                this.setState({loaded: true });
            }
        });

    }
}